import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { Redirect } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import { dateToYYYYMMDD, getFullDateAsString } from '../../utils/DateUtil';

const DownloadProfiles = (props) => {
  const { auth, profiles = [] } = props;

  const generateData = () => {
    const data = profiles.map((profile) => ({
      id: profile.id,
      name: profile.name,
      lastName: profile.lastName,
      email: profile.email,
      userName: profile.userName,
      stateCode: profile.stateCode,
      countryCode: profile.countryCode,
      gender: profile.gender,

      signUpStatus: profile.signUpStatus || '',
      platform: profile.platform || '',
      timezone: profile.timezone || '',

      idUserTL: profile.idUserTL,
      typeLicense: profile.typeLicense,
      theme: profile.theme,
      platformVersion: profile.platformVersion,
      currentVersion: profile.currentVersion,
      deviceId: profile.deviceId,
      trypscoreId: profile.trypscoreId,
      vehicleId: profile.vehicleId,
      distanceUnit: profile.distanceUnit,
      trypSource: profile.trypSource,
      socialNetwork: profile.socialNetwork,
      
      level: profile.level,
      levelXp: profile.levelXp,
      totalXp: profile.totalXp,

      //pwTL: profile.pwTL,
      //fcmToken: profile.fcmToken,

      tlVehicleAssigned: profile.tlVehicleAssigned ? 'YES' : 'NO',
      isAdmin: profile.isAdmin ? 'YES' : 'NO',
      offline: profile.offline ? 'YES' : 'NO',
      useCache: profile.useCache ? 'YES' : 'NO',
      readyToTrack: profile.readyToTrack ? 'YES' : 'NO',
      testCache: profile.testCache ? 'YES' : 'NO',
      isDailySummaryNotificationEnabled: profile.isDailySummaryNotificationEnabled ? 'YES' : 'NO',
      isTrypStartingNotificationEnabled: profile.isTrypStartingNotificationEnabled ? 'YES' : 'NO',
      isTrypEndingNotificationEnabled: profile.isTrypEndingNotificationEnabled ? 'YES' : 'NO',
      isChatNotificationEnabled: profile.isChatNotificationEnabled ? 'YES' : 'NO',

      birthDate: dateToYYYYMMDD(profile.birthDate),
      createdAt: dateToYYYYMMDD(profile.createdAt),
      updatedAt: dateToYYYYMMDD(profile.updatedAt),
    }));
    return data;
  };


  const renderButtons = () => (
    <div className="row">
      <CSVLink
        className="col s3 waves-effect waves-light btn-small"
        data={generateData()} filename={`Profiles_${getFullDateAsString()}.csv`}
        disabled={profiles.length === 0}>
        Export data to CSV
      </CSVLink>
    </div>
  );



  if (!auth.uid) return <Redirect to="/signin" />;
  return (
    <div className="container">
      <div className="title-section">Download Profiles</div>
      {renderButtons()}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profiles: state.firestore.ordered.profiles,
  };
};

export default compose(
  firestoreConnect([
    {
      collection: 'profiles',
      orderBy: ['email']
    }]),
  connect(mapStateToProps))(DownloadProfiles);
